import React from "react";
import { Truck, BadgeIndianRupee, RotateCcw, Sparkles } from "lucide-react";
import { TRUST_BADGES } from "@/data/products";

const ICONS = { Truck, BadgeIndianRupee, RotateCcw, Sparkles };

const TrustBadges = () => {
  return (
    <section className="py-14 lg:py-20 border-y border-sectionbreak" style={{ background: "#FDF6F0" }} data-testid="trust-badges">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 lg:gap-10 max-w-[1000px] mx-auto">
          {TRUST_BADGES.map((badge, idx) => {
            const Icon = ICONS[badge.icon] || Sparkles;
            return (
              <div key={idx} className="text-center lg:text-left flex flex-col lg:flex-row items-center lg:items-start gap-4" data-testid={`trust-badge-${idx}`}>
                <div className="w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: "#FBEAF0", color: "#C5985A" }}>
                  <Icon size={22} />
                </div>
                <div>
                  <h4 className="font-serif text-plum text-xl mb-1">{badge.title}</h4>
                  <p className="text-[13px] text-plum/65">{badge.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
